import { z } from 'zod';

export const toggleMfaPostResponseSchema = z.object({
  data: z.object({ secret_code: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
